import { createContext } from "react";

const ColorModeContext = createContext<{
  toggleColorMode: (mode: string) => void;
}>({
  toggleColorMode: () => {
    //
  },
});

export default ColorModeContext;
